import "./index.scss";
import React from "react";
import List from "devextreme-react/list";
import { IMdaeListProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

const MdaeList: React.FC<IMdaeListProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-list-container"}>
      <List
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_LIST,
            e.component,
            dispatch
          );
        }}
      ></List>
      <span className={"mdae-text-box-field-set-text"}>
        {props.mdaeListTitle}
      </span>
    </div>
  );
};
export default MdaeList;
